// extracted by mini-css-extract-plugin
export default {"teamMemberSelector":"OurTeam_teamMemberSelector__hLtLO"};